/*
 * AMY B. — "Avvisami quando torna disponibile" (Klaviyo Back in Stock).
 *
 * Mostra il blocco [data-back-in-stock] quando la variante selezionata è
 * esaurita e iscrive l'email alla notifica back-in-stock con la Client API
 * di Klaviyo. Il company_id viene letto dallo script klaviyo.js che l'app
 * embed inietta in pagina: senza app embed attivo il blocco resta nascosto
 * al submit e mostra un errore, ma non rompe nulla.
 *
 * I blocchi possono arrivare anche dopo il primo load (quick view): un
 * MutationObserver inizializza quelli nuovi.
 */
(function() {
  if (window.amybBackInStock) return;
  window.amybBackInStock = true;

  var API_REVISION = '2024-10-15';

  function companyId() {
    var script = document.querySelector('script[src*="klaviyo.js"][src*="company_id="]');
    if (!script) return null;
    var match = script.src.match(/[?&]company_id=([^&]+)/);
    return match ? match[1] : null;
  }

  function showMessage(box, text, isError) {
    var message = box.querySelector('[data-back-in-stock-message]');
    message.textContent = text;
    message.classList.toggle('product-back-in-stock__message--error', !!isError);
    message.hidden = false;
  }

  function subscribe(box, email) {
    var id = companyId();
    if (!id) {
      showMessage(box, 'Servizio momentaneamente non disponibile, riprova più tardi.', true);
      return;
    }
    fetch('https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=' + encodeURIComponent(id), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', revision: API_REVISION },
      body: JSON.stringify({
        data: {
          type: 'back-in-stock-subscription',
          attributes: {
            channels: ['EMAIL'],
            profile: { data: { type: 'profile', attributes: { email: email } } }
          },
          relationships: {
            variant: { data: { type: 'catalog-variant', id: '$shopify:::$default:::' + box.dataset.variantId } }
          }
        }
      })
    }).then(function(res) {
      if (!res.ok) throw new Error('HTTP ' + res.status);
      box.querySelector('[data-back-in-stock-form]').hidden = true;
      box.querySelector('[data-back-in-stock-toggle]').hidden = true;
      showMessage(box, 'Fatto! Ti scriveremo appena questa taglia torna disponibile.', false);
    }).catch(function() {
      showMessage(box, 'Non siamo riusciti a registrare la richiesta, riprova tra poco.', true);
    });
  }

  function initBox(box) {
    if (box.dataset.bisReady) return;
    box.dataset.bisReady = 'true';

    var toggle = box.querySelector('[data-back-in-stock-toggle]');
    var form = box.querySelector('[data-back-in-stock-form]');

    box.hidden = box.dataset.variantAvailable === 'true';

    toggle.addEventListener('click', function() {
      form.hidden = !form.hidden;
      toggle.setAttribute('aria-expanded', form.hidden ? 'false' : 'true');
      if (!form.hidden) form.querySelector('input[type=email]').focus();
    });

    form.addEventListener('submit', function(e) {
      e.preventDefault();
      var email = form.querySelector('input[type=email]').value.trim();
      if (email) subscribe(box, email);
    });
  }

  document.addEventListener('product:variant-change', function(e) {
    if (!e.detail) return;
    document.querySelectorAll('[data-back-in-stock]').forEach(function(box) {
      if (box.dataset.section !== e.detail.sectionId) return;
      var variant = e.detail.variant;
      if (!variant || !variant.id) {
        // Combinazione senza variante ("Non disponibile"): niente da notificare
        box.hidden = true;
        return;
      }
      box.dataset.variantId = variant.id;
      box.hidden = !!variant.available;
    });
  });

  function scan(root) {
    (root.querySelectorAll ? root.querySelectorAll('[data-back-in-stock]') : []).forEach(initBox);
  }
  scan(document);

  new MutationObserver(function(mutations) {
    mutations.forEach(function(m) {
      m.addedNodes.forEach(function(node) {
        if (node.nodeType !== 1) return;
        if (node.matches && node.matches('[data-back-in-stock]')) initBox(node);
        else scan(node);
      });
    });
  }).observe(document.body, { childList: true, subtree: true });
})();
